import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    heading: {
      fontSize: theme.typography.pxToRem(17),
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      lineHeight: "28px",
    },
    heading2: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      lineHeight: "28px",
    },
    boxBackground: {
      backgroundColor: "red",
    },
    rteLabel: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      lineHeight: "18px",
    },
    paperBackgroundColor: {
      backgroundColor: "#f3f3f3",
    },
    CustomMuiDrawer: {
      "& .MuiDrawer-paper": {
        top: "64px",
        height: "calc(100% - 64px)",
      },
    },
    swipeableDrawer: {
      width: 300,
      marginTop: "80",
    },
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: "#fff",
    },
    daysBlock: {
      paddingTop: "5px",
      float: "left",
      width: "300px",
    },
    dayItem: {
      maxWidth: "65px",
    },
    sampleLabel: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightRegular,
      color: "rgba(0, 0, 0, 0.54)",
      lineHeight: "18px",
    },
    tabPanelHead: {
      display: "flex",
      width: "100%",
      margin: "0px 0 0px",
      justifyContent: "space-between",
      alignItems: "center",
      fontFamily: "Inter",
    },
    formRow: {
      marginBottom: "0px",
    },
    tabCardContent: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      overflow: "auto",
    },
    UserMainPanel: {
      width: "100%",
      float: "left",
      padding: "0px 20px",
    },
    formControl: {
      width: "100%",
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    sectionHeadingFirstSec: { marginBottom: "40px !important" },
    sectionHeading: {
      marginTop: "20px",
      marginBottom: "20px",
      "& .MuiTypography-root": { fontWeight: "bold", fontSize: "15px" },
    },
    dateTime: { width: "100%", "& .MuiOutlinedInput-input": { padding: "10px" } },
    customTextField: {
      "& .MuiInputLabel-outlined": { fontWeight: "bold", color: "black" },
      "& .MuiFormLabel-asterisk": { fontWeight: "bold", color: "red" },
    },
    multiselectConfigFileCompression: {
      position: "relative",
      paddingLeft: "4px",
      "& .searchWrapper": {
        border: "none",
        maxHeight: "35px",
        overflow: "auto",
      },
      "& ::placeholder": {
        color: "#bcbcbc",
      },
    },
  })
);
